var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PaginatedTable',{ref:"table",attrs:{"id":"pagamentos-retirados","title":"Retiradas","hideSearch":"","headers":_vm.cabecalho,"sort-desc":true,"data-fetcher":_vm.api.pagamentos.indexarRetirados},on:{"click:row":_vm.handleClickRow}})}
var staticRenderFns = []

export { render, staticRenderFns }